import type { RouteRecordRaw } from "vue-router"

export function getDashboardRoutes(): RouteRecordRaw[] {
  return [
    {
      path: "/",
      name: "home",
      redirect: { name: "dashboard" },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import(/* webpackChunkName: "dashboard-dashboard" */ "./views/LegacyDashBoardView.vue"),
    },
    {
      path: "/dashboard-new",
      name: "dashboard-new",
      component: () => import(/* webpackChunkName: "dashboard-new" */ "./views/DashBoardView.vue"),
    },
  ]
}
